// extracted by mini-css-extract-plugin
export default {"category":"category_category__Vmiuq","category__container":"category_category__container__KNe8A"};